import { useState } from "react";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { TopupcardTable, TopupcardSearchFilter } from "./component";
import { CreateTopupModal } from "../../Modal/Topup/CreateTopupModal";
import { Topup, TopupProps } from "./types";
import { EditTopupModal } from "../../Modal/Topup/EditTopupModal";
import { DeleteTopupPlanModal } from "../../Modal/Topup/DeleteTopupPlan";

export const TopupCard: React.FC<TopupProps> = ({
  topupcardPlans,
  loading,
  statusFilter,
  setStatusFilter,
  onTopupPlanClick,
  searchTerm,
  setSearchTerm,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedTopupCardPlan, setSelectedTopupPlan] = useState<
    undefined | Topup
  >(undefined);
  const [topupPlanId, setTopupPlanId] = useState<number | null>(null);

  const onEditClick = (topup: Topup) => {
    setSelectedTopupPlan(topup);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setTopupPlanId(id);
    setIsDeleteModalOpen(true);
  };

  return (
    <ExternalContainer>
      <div className="min-h-screen dark:bg-[#FFFFFF1A] w-full max-w-7xl mx-auto px-4 py-6">
        <InternalContainer headerText="Top Up Card Plans">
          <div className="flex flex-col">
            <TopupcardSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
            />
            <div className="border border-[#FFFFFF1A] overflow-x-auto">
              <TopupcardTable
                topupPlans={topupcardPlans}
                statusFilter={statusFilter}
                searchTerm={searchTerm}
                onTopupPlanClick={onTopupPlanClick}
                onDeleteClick={onDeleteClick}
                onEditClick={onEditClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateTopupModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditTopupModal
          isOpen={isEditModalOpen && selectedTopupCardPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedTopupPlan(undefined);
          }}
          topupPlan={selectedTopupCardPlan}
        />
        <DeleteTopupPlanModal
          isOpen={isDeleteModalOpen && topupPlanId !== null}
          id={topupPlanId}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setTopupPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default TopupCard;
